import React from 'react'
import { withIcon } from '../../withIcon'

function CircularAddIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 1024 1024">
      <g transform="translate(0, 960) scale(1, -1)">
        <path d="M512-40.369c-269.719 0-488.369 218.65-488.369 488.369s218.65 488.369 488.369 488.369c269.719 0 488.369-218.65 488.369-488.369v0c0-269.719-218.65-488.369-488.369-488.369v0zM512 904.862c-252.318 0-456.862-204.544-456.862-456.862s204.544-456.862 456.862-456.862c252.318 0 456.862 204.544 456.862 456.862v0c0 252.318-204.544 456.862-456.862 456.862v0zM512 660.677c0.094 0.001 0.206 0.002 0.317 0.002 12.767 0 23.137-10.261 23.313-22.986v-166.063h166.046c12.141-0.050 22.074-9.435 22.996-21.346l0.005-0.079v-2.206c0.001-0.094 0.002-0.206 0.002-0.317 0-12.767-10.261-23.137-22.986-23.313h-166.063v-166.046c-0.050-12.141-9.435-22.074-21.346-22.996l-0.079-0.005h-2.206c-0.094-0.001-0.206-0.002-0.317-0.002-12.767 0-23.137 10.261-23.313 22.986v166.063h-166.046c-12.141 0.050-22.074 9.435-22.996 21.346l-0.005 0.079v2.206c-0.001 0.094-0.002 0.206-0.002 0.317 0 12.767 10.261 23.137 22.986 23.313h166.063v166.046c0.050 12.141 9.435 22.074 21.346 22.996l0.079 0.005z" fill={color}/>
      </g>
    </svg>
  )
}

export default withIcon(CircularAddIcon)
